/* ==========================================================================
   Kinh lup kieu "external" tren anh san pham — dung theo seensense.

   So do do truc tiep tren trang ho (ho dung thu vien Drift):
     .drift-bounding-box  khung kinh lup 260x260 nam tren anh
     .drift-zoom-pane     bang phong to 520x520, dat ben PHAI anh, cach 30px,
                          canh tren trung voi canh tren anh
     anh trong bang rong 1080 tren anh hien 540  ->  he so phong 2x
     bang = khung x 2      (dung bang he so, nen vung trong khung hien dung
                            het trong bang, khong thua khong thieu)

   Day la ban viet lai, khong keo theo thu vien nao.
   Chi chay tren may co chuot that va man hinh >= 990px.
   ========================================================================== */
(function () {
  "use strict";

  var HE_SO = 2; /* he so phong, giong ho */
  var CANH_BANG = 520; /* canh bang phong to (px) */
  var KHE = 30; /* khoang cach tu anh sang bang */

  function dungDuoc() {
    return window.matchMedia(
      "(hover: hover) and (pointer: fine) and (min-width: 990px)"
    ).matches;
  }

  /* Doi URL anh Shopify sang ban do phan giai cao hon.
     Can it nhat rong-hien-thi x HE_SO diem anh moi khong bi vo. */
  function anhNetCao(img) {
    var src = img.currentSrc || img.src || "";
    if (!src) return "";
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, "$1width=1946");
    if (src.indexOf("?") >= 0) return src + "&width=1946";
    return src + "?width=1946";
  }

  function anhDangHien(gallery) {
    var v = gallery.querySelector('[id^="GalleryViewer"]');
    if (!v) return null;
    return (
      v.querySelector(".product__media-item.is-active img") ||
      v.querySelector(".product__media-item img")
    );
  }

  function gan(gallery) {
    if (gallery.dataset.klsZoom) return;
    gallery.dataset.klsZoom = "1";

    var khung = document.createElement("div"); /* khung kinh lup */
    khung.className = "kls-lens";
    var bang = document.createElement("div"); /* bang phong to */
    bang.className = "kls-zoom-pane";
    gallery.appendChild(khung);
    gallery.appendChild(bang);

    var canhKhung = CANH_BANG / HE_SO;

    /* Cot anh va cot thong tin deu la position:sticky voi z-index:2.
       Cot thong tin dung SAU trong DOM nen ve de len bang phong to.
       Trong luc phong thi nang cot anh len tren. */
    var cot = gallery.closest(".product__media-wrapper");

    function an() {
      khung.style.display = "none";
      bang.style.display = "none";
      if (cot) cot.classList.remove("kls-dang-zoom");
    }

    function hien() {
      khung.style.display = "block";
      bang.style.display = "block";
      if (cot) cot.classList.add("kls-dang-zoom");
    }

    function ve(e) {
      if (!dungDuoc()) return an();
      var img = anhDangHien(gallery);
      if (!img || !img.naturalWidth) return an();

      var ka = img.getBoundingClientRect();
      var kg = gallery.getBoundingClientRect();
      if (!ka.width || !ka.height) return an();

      /* chuot co dang o tren anh khong */
      if (
        e.clientX < ka.left ||
        e.clientX > ka.right ||
        e.clientY < ka.top ||
        e.clientY > ka.bottom
      ) {
        return an();
      }

      /* khung kinh lup khong duoc to hon chinh buc anh */
      var cw = Math.min(canhKhung, ka.width);
      var ch = Math.min(canhKhung, ka.height);

      /* vi tri khung: lay chuot lam tam, ghim trong long anh */
      var x = e.clientX - ka.left - cw / 2;
      var y = e.clientY - ka.top - ch / 2;
      x = Math.max(0, Math.min(x, ka.width - cw));
      y = Math.max(0, Math.min(y, ka.height - ch));

      khung.style.width = cw + "px";
      khung.style.height = ch + "px";
      khung.style.left = Math.round(ka.left - kg.left + x) + "px";
      khung.style.top = Math.round(ka.top - kg.top + y) + "px";

      /* bang phong to: canh tren trung canh tren anh, nam ben phai gallery */
      bang.style.width = cw * HE_SO + "px";
      bang.style.height = ch * HE_SO + "px";
      bang.style.left = Math.round(kg.width + KHE) + "px";
      bang.style.top = Math.round(ka.top - kg.top) + "px";

      bang.style.backgroundImage = 'url("' + anhNetCao(img) + '")';
      bang.style.backgroundSize =
        Math.round(ka.width * HE_SO) + "px " + Math.round(ka.height * HE_SO) + "px";
      bang.style.backgroundPosition =
        "-" + Math.round(x * HE_SO) + "px -" + Math.round(y * HE_SO) + "px";

      hien();
    }

    gallery.addEventListener("mouseenter", ve, true);
    gallery.addEventListener("mousemove", ve, true);
    gallery.addEventListener("mouseleave", an, true);
    window.addEventListener("scroll", an, { passive: true });
    an();
  }

  function chay() {
    if (!dungDuoc()) return;
    document
      .querySelectorAll(".product__media-wrapper media-gallery")
      .forEach(gan);
  }

  document.addEventListener("DOMContentLoaded", chay);
  document.addEventListener("shopify:section:load", chay);
  window.addEventListener("resize", function () {
    clearTimeout(window.__klsZoomT);
    window.__klsZoomT = setTimeout(chay, 200);
  });
})();
